module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "cummins_logo_white.cf7c2eb0.png";